import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function RoomTag(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_1045_70)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M13.282 5.062A4.5 4.5 0 005.257 6h.973a.193.193 0 00.05-.03.786.786 0 00.196-.232 3.5 3.5 0 114.85 4.75l-.01.004-2.2 1.312a2 2 0 00-.68 2.761l3.484 5.697a1 1 0 001.364.338l5.983-3.557a1 1 0 00.348-1.372l-6.333-10.61zM6.226 6h.003-.003zm-.23-3.976a6.5 6.5 0 018.995 1.998l6.34 10.623a3 3 0 01-1.042 4.116l-5.982 3.557a3 3 0 01-4.093-1.013L6.73 15.609a4 4 0 011.363-5.522l2.194-1.31a1.5 1.5 0 10-2.082-2.034C7.884 7.293 7.224 8 6.234 8H5.12C4.015 8 2.87 6.985 3.272 5.64a6.479 6.479 0 012.724-3.615z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_1045_70"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default RoomTag;